import { useNavigate } from 'react-router-dom';
import { ArrowRight, Hourglass } from 'lucide-react';
import { SALONFLOW_PLAN_LABEL } from './salonflowPlans';
import type { SalonFlowPlanKey, TrialRemaining } from './salonflowPlans';

type Props = {
    planKey: SalonFlowPlanKey;
    trialRemaining: TrialRemaining;
};

export default function TrialBanner({ planKey, trialRemaining }: Props) {
    const navigate = useNavigate();
    const planLabel = SALONFLOW_PLAN_LABEL[planKey];
    const daysLabel =
        trialRemaining.days === 1
            ? '1 dia restante'
            : `${trialRemaining.days} dias restantes`;

    return (
        <div className="sf-gradient-card mb-4 rounded-[1.35rem] border border-warning/25 bg-warning/10 px-4 py-3 shadow-sm">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div className="flex min-w-0 items-start gap-3">
                    <span className="mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-warning/15 text-warning">
                        <Hourglass className="text-sm" aria-hidden="true" />
                    </span>
                    <div className="min-w-0">
                        <div className="text-sm font-semibold text-base-content">
                            Teste gratuito do SalonFlow
                        </div>
                        <div className="mt-0.5 text-xs leading-relaxed text-base-content/70">
                            Seu trial do plano {planLabel} está ativo: {daysLabel}. Depois do período de 14 dias,
                            o uso interno fica bloqueado até a regularização.
                        </div>
                    </div>
                </div>

                <button
                    type="button"
                    onClick={() => navigate('/meu-plano')}
                    className="btn btn-warning btn-sm shrink-0 rounded-xl gap-2"
                >
                    Contratar agora
                    <ArrowRight className="h-4 w-4" />
                </button>
            </div>
        </div>
    );
}
